import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useLogin } from '../../auth/useLogin';
import { dashboardPagePath } from '../../components/navigation/paths';
import { Spinner, useOidcAuthentication } from '@cp-shared-19/frontend-ui';
import { useTranslation } from 'react-i18next';

export const LoginRedirect: React.FC = () => {
    const { t } = useTranslation('loader');
    const { isAuthenticated } = useOidcAuthentication();
    const login = useLogin();
    const history = useHistory();

    useEffect(() => {
        if (!isAuthenticated) {
            login();
        } else {
            history.push(dashboardPagePath());
        }
    }, [history, isAuthenticated, login]);

    return (
        <Spinner center>
            <p>{t('genericText')}</p>
        </Spinner>
    );
};
